import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./fix-back-button.module.scss";
import backSvg from "@/assets/back.svg";
import { useServices } from "@/services-context";
import { FixButton } from "@/elements-react/fix-button";
import { Icon } from "@/elements-react/fix-icon";
import { Gtag } from "@/services/gtag.ts";

export interface FixBackButtonProps {
  text?: string;
  url?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  className?: string;
}

export const FixBackButton: React.FC<FixBackButtonProps> = ({ text, url, onClick, className }) => {
  const { t } = useTranslation();
  const { breadcrumbs } = useServices();

  if (!url && !onClick) {
    url = breadcrumbs.breadcrumbs[breadcrumbs.breadcrumbs.length - 2]?.url ?? undefined;
  }

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      Gtag.pushEvent("back_button_click");
      if (onClick) onClick(e);
    },
    [onClick],
  );

  const buttonText = text || t("en5102c65e3r2vnz.back", "Back");

  return (
    <FixButton
      className={classNames(styles.back, styles.size_default, className)}
      variant="text"
      href={url ?? undefined}
      onClick={handleClick}
    >
      <Icon className={styles.icon} src={backSvg} />
      <span className={classNames(styles.label)}>{buttonText}</span>
    </FixButton>
  );
};

export default FixBackButton;
